const values = [
  { icon: 'ri-shield-check-line', title: 'Licensed & Insured', desc: 'Fully licensed and insured for your peace of mind on every project.' },
  { icon: 'ri-time-line', title: 'On-Time Delivery', desc: 'We respect your timeline and deliver projects when we say we will.' },
  { icon: 'ri-star-line', title: 'Quality Craftsmanship', desc: 'Every nail, every pour, every finish — done right the first time.' },
  { icon: 'ri-group-line', title: 'Local DFW Team', desc: 'We live and work here. We care about this community as much as you do.' },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-[#F5EFE7]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
              <span className="text-orange-500 text-sm font-bold tracking-widest uppercase">About Allen Construction Group</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-6">
              Built on Trust,<br />
              <span className="text-orange-500">Driven by Excellence</span>
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-5">
              Allen Construction Group has been serving the Dallas-Fort Worth metroplex with pride. We&apos;ve built our reputation one project at a time — through honest communication, skilled labor, and a relentless commitment to quality.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              Whether you&apos;re building from the ground up, pouring a new foundation, or transforming your existing space, our team brings the expertise and dedication to make it happen. We treat every project like it&apos;s our own home.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mb-10">
              {[
                { value: '500+', label: 'Projects Done' },
                { value: '15+', label: 'Years in DFW' },
                { value: '100%', label: 'Client Satisfaction' },
              ].map((stat) => (
                <div key={stat.label} className="text-center bg-white rounded-xl p-4">
                  <div className="text-2xl md:text-3xl font-black text-orange-500">{stat.value}</div>
                  <div className="text-xs text-gray-500 mt-1 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>

            <a
              href="tel:6824502501"
              className="inline-flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-4 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill"></i>
              </div>
              Call Us: (682) 450-2501
            </a>
          </div>

          {/* Right Side */}
          <div className="flex flex-col gap-6">
            {/* Main Image */}
            <div className="w-full rounded-2xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/e845be91-21af-465c-b474-fcdc6906f86f/425ef36b-63eb-4bec-973b-0ecfe8933ce0_file_000000007f7471fd9d606c2be8c30258.png?v=870c820c67f42d571479a152c75024a5"
                alt="Allen Construction Group Team"
                className="w-full h-auto object-contain"
              />
            </div>

            {/* Values Grid */}
            <div className="grid grid-cols-2 gap-4">
              {values.map((val) => (
                <div key={val.title} className="bg-white rounded-xl p-4 flex flex-col gap-2">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-lg">
                    <i className={`${val.icon} text-orange-500 text-xl`}></i>
                  </div>
                  <div className="font-bold text-gray-900 text-sm">{val.title}</div>
                  <div className="text-gray-500 text-xs leading-relaxed">{val.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
